import axios from 'axios';
import { createAsyncThunk, createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { appendPageable, readPagedRows } from '../utils/spring-api';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const initialState = {
    loading: false,
    errorMessage: null,
    report: [],
    totalItems: 0,
};
const apiUrl = API_ROUTES.qstat.sessionReport;
function buildParams(params) {
    const q = new URLSearchParams();
    if (params.username?.trim()) {
        q.append('username', params.username.trim());
    }
    if (params.activity?.trim()) {
        q.append('activity', params.activity.trim());
    }
    if (params.dateFrom) {
        q.append('dateFrom', params.dateFrom);
    }
    if (params.dateTo) {
        q.append('dateTo', params.dateTo);
    }
    appendPageable(q, params.page, params.size, params.sort ?? 'loginTime,desc');
    return q;
}
export const getSessionReport = createAsyncThunk('sessionReport/fetch', async (params) => {
    const q = buildParams(params);
    const res = await axios.get(`${apiUrl}?${q.toString()}`);
    const { rows, total } = readPagedRows(res.data, res.headers);
    return { rows, total };
}, { serializeError: serializeAxiosError });
export const SessionReportSlice = createSlice({
    name: 'sessionReport',
    initialState: initialState,
    reducers: {
        reset() {
            return initialState;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getSessionReport.fulfilled, (state, action) => {
            state.loading = false;
            state.report = action.payload.rows;
            state.totalItems = action.payload.total;
        })
            .addMatcher(isPending(getSessionReport), state => {
            state.errorMessage = null;
            state.loading = true;
        })
            .addMatcher(isRejected(getSessionReport), (state, action) => {
            state.loading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { reset } = SessionReportSlice.actions;
export default SessionReportSlice.reducer;
